module.exports = __webpack_public_path__ + "img/logo.2cb16d06.svg";